import {ComponentProps} from "react";
import {css} from "@panda/css";

import {Link} from "@pg-design/link-module";
import {Text} from "@pg-design/text-module";
import {rpAppLink} from "@pg-mono/rp-routes";

interface IProps extends ComponentProps<typeof Text> {
    buttonText: string;
}

export function LeadButtonTerms(props: IProps) {
    const {buttonText, as = "span", color = "var(--colors-gray-800)", variant = "info_txt_3"} = props;
    const termsOfServiceUrl = rpAppLink.termsOfService.base();

    return (
        <Text as={as} variant={variant} color={color} {...props}>
            Kliknięcie „{buttonText}” oznacza zgodę na zawarcie z Property Group sp. z o.o. umowy na świadczenie usług automatycznego dopasowania i zarzadzania
            ofertami nieruchomości w ramach konta mieszkaniowego na warunkach określonych w{" "}
            <Link href={termsOfServiceUrl} target="_blank" textClassName={termsLink}>
                Regulaminie
            </Link>
            .
        </Text>
    );
}

const termsLink = css({
    fontSize: "inherit",
    lineHeight: "inherit",
    textDecoration: "underline"
});
import {ComponentProps} from "react";
import {css} from "@panda/css";

import {Link} from "@pg-design/link-module";
import {Text} from "@pg-design/text-module";
import {rpAppLink} from "@pg-mono/rp-routes";

interface IProps extends ComponentProps<typeof Text> {
    buttonText: string;
}

export function LeadButtonTerms(props: IProps) {
    const {buttonText, as = "span", color = "var(--colors-gray-800)", variant = "info_txt_3"} = props;
    const termsOfServiceUrl = rpAppLink.termsOfService.base();

    return (
        <Text as={as} variant={variant} color={color} {...props}>
            Kliknięcie „{buttonText}” oznacza zgodę na zawarcie z Property Group sp. z o.o. umowy na świadczenie usług automatycznego dopasowania i zarzadzania
            ofertami nieruchomości w ramach konta mieszkaniowego na warunkach określonych w{" "}
            <Link href={termsOfServiceUrl} target="_blank" textClassName={termsLink}>
                Regulaminie
            </Link>
            .
        </Text>
    );
}

const termsLink = css({
    fontSize: "inherit",
    lineHeight: "inherit",
    textDecoration: "underline"
});
